module.exports = __webpack_public_path__ + "static/media/urbangoo05.af268486.webp";